import script from "./admin-user.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-user.vue?vue&type=script&setup=true&lang=js"

import "./admin-user.vue?vue&type=style&index=0&id=6c2f7d5f&lang=scss"

const __exports__ = script;

export default __exports__